/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const UsernameAvailability = {
    AVAILABLE: 'AVAILABLE',
    TAKEN: 'TAKEN',
    NOT_ALLOWED: 'NOT_ALLOWED'
} as const;
export type UsernameAvailability = typeof UsernameAvailability[keyof typeof UsernameAvailability];


export function instanceOfUsernameAvailability(value: any): boolean {
    for (const key in UsernameAvailability) {
        if (Object.prototype.hasOwnProperty.call(UsernameAvailability, key)) {
            if (UsernameAvailability[key as keyof typeof UsernameAvailability] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UsernameAvailabilityFromJSON(json: any): UsernameAvailability {
    return UsernameAvailabilityFromJSONTyped(json, false);
}

export function UsernameAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsernameAvailability {
    return json as UsernameAvailability;
}

export function UsernameAvailabilityToJSON(value?: UsernameAvailability | null): any {
    return value as any;
}

export function UsernameAvailabilityToJSONTyped(value: any, ignoreDiscriminator: boolean): UsernameAvailability {
    return value as UsernameAvailability;
}

